// User-provided single-stock ETF pairs. Missing inverse tickers are omitted.
export const ETF_PAIRS = [
  ['TSLA', 'Tesla', 'TSLL', 'TSLS'],
  ['NVDA', 'NVIDIA', 'NVDU', 'NVDD'],
  ['AAPL', 'Apple', 'AAPU', 'AAPD'],
  ['MSFT', 'Microsoft', 'MSFU', 'MSFD'],
  ['AMZN', 'Amazon', 'AMZU', 'AMZD'],
  ['GOOGL', 'Alphabet', 'GGLL', 'GGLS'],
  ['META', 'Meta Platforms', 'METU', 'METD'],
  ['AMD', 'Advanced Micro Devices', 'AMUU', 'AMDD'],
  ['AVGO', 'Broadcom', 'AVL', 'AVS'],
  ['PLTR', 'Palantir', 'PLTU', 'PLTD'],
  ['NFLX', 'Netflix', 'NFXL', 'NFXS'],
  ['MU', 'Micron', 'MUU', 'MUD'],
  ['PANW', 'Palo Alto Networks', 'PALU', 'PALD'],
  ['ORCL', 'Oracle', 'ORCU', 'ORCS'],
  ['CSCO', 'Cisco', 'CSCL', 'CSCS'],
  ['PYPL', 'PayPal', 'PYPU'],
  ['BA', 'Boeing', 'BOEU'],
  ['LLY', 'Eli Lilly', 'ELIL'],
  ['INTC', 'Intel', 'LINT'],
  ['LMT', 'Lockheed Martin', 'LMTL'],
  ['ADBE', 'Adobe', 'ADBU'],
  ['MRVL', 'Marvell', 'MRVU'],
  ['BRK.B', 'Berkshire Hathaway', 'BRKU'],
];

export const ETF_SYMBOL_DATA = ETF_PAIRS.flatMap(([underlying, company, ...symbols]) =>
  symbols.map((symbol, index) => ({
    symbol,
    name: `${company} (${underlying}) ${index === 0 ? 'Bull' : 'Bear'} ETF`,
  }))
);
